export enum SyncOptionsContactExport {
  NO_EXPORT = 'NO_EXPORT',
  PERSONAL_CONTACTS = 'PERSONAL_CONTACTS',
  ALL_CONTACTS = 'ALL_CONTACTS',
}
